import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { fetchSubcategoriesRequest } from '../../store/masters/actions';

const selectorMap = {
    subcategories: state => state.masters.subcategories,
};

const IMMasterSubCategoryMultiSelect = ({ collectionName, selectedValues, onChange, label }) => {
    const dispatch = useDispatch();
    const subcategories = useSelector(selectorMap.subcategories);
    const loading = useSelector(state => state.masters.loading);
    const error = useSelector(state => state.masters.error);

    useEffect(() => {
        if (collectionName) {
            dispatch(fetchSubcategoriesRequest(collectionName));
        }
    }, [dispatch, collectionName]);

    const options = subcategories.map(item => ({
        value: item.id,
        label: item.name,
    }));

    const selectedOptions = Array.isArray(selectedValues)
        ? selectedValues.map(value => options.find(option => option.value === value.id))
        : [];

    const handleChange = (selected) => {
        const selectedItems = selected ? selected.map(option => ({ id: option.value, label: option.label })) : [];
        onChange(selectedItems);
    };

    return (
        <div className="mb-3">
            <label className="control-label">{label}</label>
            <Select
                value={selectedOptions}
                onChange={handleChange}
                options={options}
                isMulti
                isLoading={loading}
                classNamePrefix="select2-selection"
                placeholder={`Select ${label.toLowerCase()}...`}
            />
            {error && <div className="text-danger">{error}</div>}
        </div>
    );
};

export default IMMasterSubCategoryMultiSelect;